import { GetterTree } from 'vuex'
import { StoreInterface } from '../index'
import { LocalStateInterface } from './state'
import { MenuItem } from 'src/types'

const getters: GetterTree<LocalStateInterface, StoreInterface> = {
  getMenus: (state): Array<MenuItem> => {
    return state.menus.filter((menu: MenuItem) => {
      if (!menu.roles) return true
      // return menu.roles.includes(DefaultRole.TEACHER || DefaultRole.PARENT)
      return menu.roles
    })
  },

  getLevelsOptions: (state: LocalStateInterface): any => state.levels,

  getSubjectOptions: (state: LocalStateInterface): any => state.subjects
}

export default getters
